var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.buttonList),function(item){return _c('el-button',{key:item.id,attrs:{"type":item.buttonType},on:{"click":function($event){_vm.callFunc(item)}}},[_vm._v("\n    "+_vm._s(item.name))])}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }